/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { TimeOfDay } from '../models/TimeOfDay';
import { TimeOfYear } from '../models/TimeOfYear';

export class AnnuallyConfig {
  'timeOfDay'?: TimeOfDay;
  'timeOfYear'?: TimeOfYear;
  /**
  * The window of time after the start time you want the backup to start, in minutes. Defaults to `240` (4 hours). 
  */
  'startWindowMinutes'?: number;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "timeOfDay",
      "baseName": "timeOfDay",
      "type": "TimeOfDay",
      "format": ""
    },
    {
      "name": "timeOfYear",
      "baseName": "timeOfYear",
      "type": "TimeOfYear",
      "format": ""
    },
    {
      "name": "startWindowMinutes",
      "baseName": "startWindowMinutes",
      "type": "number",
      "format": "long"
    }  ];

  static getAttributeTypeMap() {
    return AnnuallyConfig.attributeTypeMap;
  }

  public constructor() {
  }
}

